import { ORGANIZATION_ROLES } from '@highlight-cp/constants';

import { useGetCurrentUser } from '../use-get-current-user';

const useGetCurrentUserRoles = () => {
  const { data: user, isLoading } = useGetCurrentUser();

  return {
    isLoading,
    isOrgAdmin: user?.organizationRole === ORGANIZATION_ROLES.ADMIN,
    isResearcher: user?.organizationRole === ORGANIZATION_ROLES.RESEARCHER,
    isViewer: user?.organizationRole === ORGANIZATION_ROLES.VIEWER,
  };
};

export default useGetCurrentUserRoles;
